import { getPathStorageFromLocalStorage } from '@/helpers/managePrevPath';
import { IResponseDetailMaterial } from '@/interfaces/doccen-lib/contentManagement.interface';
import { PATH_NAME } from 'configs/pathName';
import { BreadcrumbItem } from 'design-system/components/Breadcrumb';
import Header from 'design-system/components/Header/Header';
import { useMemo } from 'react';

const DocumentDetailHeader = ({
  material,
}: {
  material: IResponseDetailMaterial | undefined;
}) => {
  const breadcrumb: BreadcrumbItem[] = useMemo(() => {
    const baseBreadcrumb = [
      {
        name: material?.material.name || '',
        path: '#',
        className: 'line-clamp-none whitespace-nowrap',
      },
    ];

    const preparedLevel = [
      {
        name: 'Thư viện Doccen',
        path: PATH_NAME.LIBRARY,
        className: 'line-clamp-none whitespace-nowrap',
      },
    ];

    const storage = getPathStorageFromLocalStorage();

    if (storage.length > 1) {
      const level = {
        name: 'Thư viện Doccen',
        path: PATH_NAME.LIBRARY,
        className: '',
      };

      const previousPath = storage[storage.length - 2] as string;

      const possiblePrevPath = [
        {
          pathName: PATH_NAME.HOME_FEED_SEARCH,
          name: 'Tìm kiếm',
        },
        {
          pathName: PATH_NAME.LIBRARY,
          name: 'Thư viện Doccen',
        },
        {
          pathName: PATH_NAME.LIBRARY_CONTENT_MANAGEMENT,
          name: 'Quản lý nội dung',
        },
      ];

      possiblePrevPath.forEach((item) => {
        if (previousPath.includes(item.pathName)) {
          level.name = item.name;
          level.path = item.pathName;
          return;
        }
      });

      if (level.path === PATH_NAME.LIBRARY_CONTENT_MANAGEMENT) {
        preparedLevel.push(level);
      } else {
        preparedLevel.splice(0, 1, level);
      }
    }
    return preparedLevel.concat(baseBreadcrumb);
  }, [material?.material.name]);

  return (
    <Header
      title=""
      breadcrumb={{
        breadcrumbItems: breadcrumb,
        startPlace: {
          iconName: 'library',
          title: breadcrumb[0].name,
        },
      }}
      className="!gap-0 px-3 py-2 md:px-6 md:py-4"
    />
  );
};

export default DocumentDetailHeader;
